<template>
	<transition name="fade">
		<div v-if="modalOpen" class="modal" tabindex="-1" ref="basketModal">
			<div class="modal-dialog shadow">
				<VeeForm :validation-schema="postcodeValidationSchema" v-slot="{ handleSubmit, errors }" @invalid-submit="onInvalidSubmit" as="div">
					<form class="row reg-form" @submit="handleSubmit($event, onPostcodeSubmit)" method="post" :action="this.baseUrl + '/modal-submit'" ref="modalForm">
						<div class="modal-content px-0">
							<div class="modal-header border-0 pb-2 px-4">
								<h3 class="modal-title">Your tyre selection</h3>
								<button type="button" class="btn-close" data-bs-dismiss="modal" @click="$emit('closeModal');" aria-label="Close"></button>
							</div>
							<div class="modal-body py-0 px-4 mb-4">
								<div v-for="tyre in this.basketTyres" :key="tyre.id" class="d-flex border-bottom py-2 justify-content-between align-items-center">
									<div class="col-8">
										<div v-if="tyre.tyre_position != null && tyre.tyre_position != '' && tyre.tyre_position != 'same'">
											<b>{{ tyre.tyre_position.charAt(0).toUpperCase() + tyre.tyre_position.slice(1) }} tyre</b>
										</div>
										<div v-else-if="tyre.tyre_position != null && (tyre.tyre_position == 'same' || tyre.tyre_position == '')">
											<b>Front and rear tyre</b>
										</div>
										<p class="d-block mb-0 me-3">{{ tyre.brand + ' ' + tyre.tyre_range }}</p>
										<small class="d-block mb-0">{{ tyre.description }}</small>
									</div>
									<div class="col-4 text-end">
										<p class="d-block m-0">£{{ tyre.display_price }}</p>
										<select name="quantity" id="quantity" class="d-inline-block m-2 form-select pt-1" @change="this.$parent.updateQuantity($event, tyre.st_code)">
											<option v-for="index in 5" :key="index" :value="index" :selected="index == tyre.quantity">{{ index }}</option>
										</select>
										<span @click="this.$parent.deleteFromBasket(tyre.st_code)">
											<i class="fa-regular fa-trash-can cursor-pointer"></i>
										</span>
									</div>
								</div>
								<add-more-tyres
									v-if="tyrePosition != null && tyrePosition != 'same' && tyrePositionInBasket == false"
									:tyre-position="tyrePosition"
									:tyre-position-text="tyrePositionText"
									:postcode="postcode"
									:size-options="sizeOptions"
									:errors="errors"
								></add-more-tyres>
								<div class="border-bottom pb-2 d-flex align-items-center" v-if="tyrePosition == 'same' && tyrePosition != null">
									<div>
										<b class="d-block mt-2">Add more tyres?</b>
										<p class="mb-0">Your front and rear tyres are the same size, increase the quantity for more tyres.</p>
									</div>
									<!-- <i class="fa-kit fa-chevron-up d-block mx-3"></i> -->
									<i class="fa-solid fa-turn-up d-block mx-3 fa-lg"></i>
								</div>
								<add-tyre-size
									v-if="tyrePosition == null"
									:tyre-position="tyrePosition"
									:tyre-position-text="tyrePositionText"
									:postcode="postcode"
									:size-options="sizeOptions"
									:errors="errors"
								></add-tyre-size>
								<div v-if="this.basketServices.length > 0" class="mt-3">
									<h4 class="modal-title">Your service selection</h4>
									<div v-for="service in this.basketServices" :key="service.id" class="d-flex border-bottom py-2 justify-content-between align-items-center">
										<div class="col-8">
											<p class="d-block mb-0 me-3">{{ service.service_name }}</p>
										</div>
										<div class="col-4 text-end">
											<p class="d-inline-block me-3">£{{ service.display_price }}</p>
											<span @click="this.$parent.deleteFromBasket(service.st_code)"><i class="fa-kit fa-trash cursor-pointer"></i></span>
										</div>
									</div>
								</div>
								<div class="d-flex justify-content-between align-items-center pt-2">
									<b class="float-start pt-2">Total:</b>
									<b class="float-end pt-2">£{{ basket.sub_total }}</b>
								</div>
							</div>
							<div class="modal-footer d-flex align-items-center border-0 shadow-lg">
								<div class="d-flex align-items-center gap-sm-3 flex-grow-1 flex-column flex-sm-row">
									<div class="w-100">
										<Field id="postcode" name="postcode" type="text" placeholder="Postcode" class="form-control uppercase my-2" :value="postcode" :class="{'error': errors.size_postcode}"/>
										<div class="error-msg">{{ errors.postcode}}</div>
									</div>
									<button type="submit" class="btn btn-primary mx-0 my-1 w-100" :disabled="disabled">{{ continueText }}</button>
								</div>
							</div>
						</div>
					</form>
				</VeeForm>
			</div>
		</div>
	</transition>
</template>
<script>
    import { Form as VeeForm, Field, ErrorMessage} from 'vee-validate';
    import * as yup from 'yup';
	import basketHelpers from '@shared/mixins/basketHelpers';
	import { navigateWithAttribution } from '@shared/composables/attributionNavigation.js';

    export default {
        props: ['modal-open', 'basket', 'postcode', 'tyrePosition', 'sizeOptions'],
        emits: ['closeModal', 'basket-updated'],
		mixins: [basketHelpers],
        components: {
        	VeeForm, Field, ErrorMessage
        },
        data() {
            const postcodeValidationSchema = yup.object({
                postcode: yup.string().required().nullable()
            });

            return {
            	postcodeValidationSchema
            }
        },
        methods: {
            onPostcodeSubmit(values) {
                this.emitter.emit('isLoading', true);
				
				let vm = this;
                var postcode = values.postcode;
                var formData = new FormData();
                formData.append('postcode', postcode);

				axios.post('/modal-submit', formData)
                .then(response => {
                    void navigateWithAttribution(this.baseUrl + response.data);
                })
                .catch(error => {
                    console.error("There was an error!", error);
                });
            },
			onInvalidSubmit({ values, errors, results }) {
                //Focus first invalid field
                var firstInvalidField = document.getElementsByName(Object.keys(errors)[0]);
                firstInvalidField[0].focus();
            }
        },
		computed: {
			modalContinueText() {
            	return (this.basket.home_delivery == true || (this.basket.route.includes('fitted-nationally')) ? 'Continue to checkout' : 'Choose a fitter');
			},
			tyrePositionText() {
				if(this.tyrePosition == null) return null;

				if(this.tyrePosition == 'rear') {
					return 'front';
				}
				else if(this.tyrePosition == 'front') {
					return 'rear';
				}
				else {
					return 'same';
				}
			},
			tyrePositionInBasket() {
				let tyrePositionInBasket = false;
				let vm = this;

				if(this.basket.products.length > 0) {
					_.forEach(this.basket.products, function(basketProduct, key) {
						if(basketProduct.tyre_position == vm.tyrePositionText) {
							tyrePositionInBasket = true;
						}
					});
				}

				return tyrePositionInBasket;
			}
		}
    }
</script>
<style lang="scss" scoped>
    .error {
        color: red;
    }
    .modal {
		background-color: rgba(0,0,0,.5);
	  	display: block;
		z-index: 1090;
		.modal-dialog {
			max-width: 536px;
		}
	}
	#quantity {
		width: 70px;
	}
</style>